//
import BranchOfficeModel from '@/models/General/GBranchOffice'
import WarehouseTypeModel from '@/models/Warehouse/WhWarehouseType'

//
export default ({ g_branch_office_address }) => [
    {
        name: 'g_branch_office_id',
        props: {
            chips: true,
            itemText: 'name',
            itemValue: 'id',
            label: 'Sucursal',
            model: BranchOfficeModel,
            noAsyncSearch: true,
            noObject: true,
            paramFilter: {
                address: g_branch_office_address,
            },
            paramSearch: 'address',
        },
        type: 'autocomplete-model',
    },
    {
        name: 'wh_warehouse_type_id',
        props: {
            chips: true,
            itemText: 'type',
            itemValue: 'id',
            label: 'Tipo',
            model: WarehouseTypeModel,
            noAsyncSearch: true,
            noObject: true,
            paramSearch: 'type',
        },
        type: 'autocomplete-model',
    },
    {
        name: 'is_waste_warehouse',
        props: {
            chips: true,
            items: [
                {
                    text: 'Si',
                    value: 1,
                },
                {
                    text: 'No',
                    value: 0,
                },
            ],
            label: 'Merma',
        },
        type: 'select',
    },
]
